import { Dictionary } from 'lodash';
import React from 'react';
import dairyFree from 'src/assets/svg/tikka/dietary/dairy free weight=light.svg';
import pork from 'src/assets/svg/tikka/dietary/pig slash.svg';
import wineBottle from 'src/assets/svg/tikka/dietary/wine slash.svg';
import checkmark from 'src/assets/svg/tikka/functional/checkmark weight=light, circle=yes.svg';
import slicedFish from 'src/assets/svg/tikka/protein/meat=fish - slice, weight=light.svg';
import goat from 'src/assets/svg/tikka/protein/meat=goat, weight=light.svg';
import { DietaryDetails } from 'src/gqlReactTypings.generated.d';
import styled, { css } from 'styled-components';
import { ifProp } from 'web-common/src/shared/styled-utils/ifProp';
import { Colors, Font, Spacing } from 'web-common/src/shared/styles';

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.SINGLE};
`;
export const Practice = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  color: ${Colors.GRAY_DARK_30};

  /* body */
  font-size: ${Font.Size.S};
  font-family: ${Font.Family.SANS};
  font-style: normal;
  font-weight: ${Font.Weight.MEDIUM};
  line-height: 165%;
`;
export const PracticeIcon = styled.img<{ large?: boolean }>`
  width: 24px;
  height: 24px;
  margin-right: 16px;
  ${ifProp(
    'large',
    css`
      width: 32px;
      height: 32px;
      margin-top: -4px;
      margin-right: 8px;
      margin-left: -4px;
    `
  )}
`;

const IconByQuestionId: Dictionary<React.ReactNode> = {
  'halal-pork-free': <PracticeIcon src={pork} large />,
  'halal-meats': <PracticeIcon src={goat} />,
  'gelatin-free': <PracticeIcon src={checkmark} />,
  'alcohol-free': <PracticeIcon src={wineBottle} large />,
  'halal-seafood': <PracticeIcon src={slicedFish} />,
  'halal-dairy': <PracticeIcon src={dairyFree} />,

  default: <PracticeIcon src={checkmark} />,
};

interface IProps {
  className?: string;
  dietaryDetails: DietaryDetails;
}

export const KitchenPractices: React.FC<IProps> = ({ className, dietaryDetails }) => (
  <ListContainer className={className}>
    {dietaryDetails.responses.map((response) => (
      <Practice key={response.questionId}>
        {IconByQuestionId[response.questionId] ?? IconByQuestionId.default}
        <div className='flex flex-col'>
          <span>{response.responseDisplay}</span>
          {response.responseFreeText && <span className='italic'>{response.responseFreeText}</span>}
        </div>
      </Practice>
    ))}
  </ListContainer>
);
